var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"disabled":_vm.isExporting || _vm.disabled,"title":_vm.tooltip},on:{"click":_vm.handleExport}},[(_vm.isExporting)?[_c('b-spinner',{attrs:{"small":""}}),_vm._v(" "+_vm._s(_vm.loadingText)+" ")]:[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.buttonText)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }